const THEME_KEY = 'pulsecio_theme';
const LIGHT = 'light';
const DARK = 'dark';

function applyTheme(theme) {
  const root = document.documentElement;
  
  // Optimisation : appliquer la classe avant les variables CSS
  if (theme === DARK) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  
  // Les variables CSS sont maintenant définies dans index.css et gérées par Tailwind
  // Plus besoin de les définir ici en JavaScript
}

function getStoredTheme() {
  try {
    return localStorage.getItem(THEME_KEY) || null;
  } catch (e) {
    return null;
  }
}

function setStoredTheme(theme) {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch (e) {}
}

export function initTheme() {
  const stored = getStoredTheme();
  if (stored) {
    applyTheme(stored === DARK ? DARK : LIGHT);
    window.dispatchEvent(new CustomEvent('theme-change', { detail: stored === DARK ? DARK : LIGHT }));
    return stored === DARK ? DARK : LIGHT;
  }

  const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const initial = prefersDark ? DARK : LIGHT;
  applyTheme(initial);
  window.dispatchEvent(new CustomEvent('theme-change', { detail: initial }));
  return initial;
}

export function toggleTheme(current) {
  const next = current === DARK ? LIGHT : DARK;
  applyTheme(next === DARK ? DARK : LIGHT);
  setStoredTheme(next);
  window.dispatchEvent(new CustomEvent('theme-change', { detail: next }));
  return next;
}

export { LIGHT, DARK };